/* eslint-disable filename-export/match-default-export */

const ANALYTICS_BUILDER_EVENTS = {
  ANALYTICS_FILE_UPLOAD_FEATURE_VIEWED: 'analytics_file_upload_feature_viewed',
  ANALYTICS_FILE_UPLOAD_COMPLETE: 'analytics_file_upload_complete',
  ANALYTICS_FILE_DOWNLOADED: 'analytics_file_downloaded',
};

export default ANALYTICS_BUILDER_EVENTS;
